import React from 'react';

const CategoryMasterPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default CategoryMasterPage;
